import { useQuery } from 'react-query'
import { SearchConsumablesParams, SearchConsumablesResponse } from './types'
import { useCreateBetterIdRequest } from 'lib/services/config/betterId-config'

export const useSearchConsumables = (params: SearchConsumablesParams) => {
  const { createBetterIdRequest } = useCreateBetterIdRequest()
  const url = 'operations/assets/find-consumables'
  return useQuery<SearchConsumablesResponse, Error>(
    ['searchConsumables', params],
    () => createBetterIdRequest(url, params, 'GET'),
    {
      keepPreviousData: true,
    }
  )
}
